export default class EdlioApiException extends Error {
  constructor(message, res) {
    super();
    this.name = 'EdlioApiException';
    this.message = `${res.status}: ${message}`;
    this.status = res.status;
    this.response = res;
    this.rawResponseBody = message;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapps/common/edlio-js/exceptions/EdlioApiException.js